import styled from 'styled-components';

const MainLayoutWrapper = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  padding: 0;
  margin: 0;
  background: black;
`;

export default MainLayoutWrapper;
